<template>
  <section class="cta">
    <div class="container cta__inner">
      <h2 class="cta__title">Готовы увидеть расчёт ваших премий?</h2>
      <p class="cta__text">Получите демо-доступ на 14 дней — настроим систему под ваши формулы и сверим итог с вашим Excel</p>
      <div class="cta__actions">
        <base-button to="/demo" size="lg" variant="ghost">Получить демо-доступ</base-button>
        <base-button to="/contacts" size="lg" variant="ghost">Связаться с нами</base-button>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue'
export default {
  name: 'CtaSection',
  components: { BaseButton },
}
</script>

<style scoped>
.cta {
  background: linear-gradient(135deg, #1E3A8A 0%, #2563EB 100%);
  padding: 96px 0;
  text-align: center;
  color: white;
}
.cta__title {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 16px;
}
.cta__text {
  font-size: 1.125rem;
  opacity: 0.85;
  margin-bottom: 40px;
}
.cta__actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

@media (max-width: 600px) {
  .cta__title { font-size: 1.75rem; }
}
</style>
